export default __webpack_public_path__ + "static/media/idlogo.be600481.png";